import { useCallback } from 'react';

import { useLocalActivityCacheStoreActions } from '@confluence/legacy-schema-bridge/entry-points/useLocalActivityCache.ts';
import type { LocalActivityAction } from '@confluence/legacy-schema-bridge/entry-points/useLocalActivityCache.ts';

import { trackLocalActivity } from './useLocalActivity.ts';

interface LocalActivityTracker {
	track(contentId: string, action: LocalActivityAction): void;
}

export const useLocalActivityTracker = (): LocalActivityTracker => {
	const { getLocalActivity, setLocalActivity } = useLocalActivityCacheStoreActions();

	const track = useCallback(
		(contentId: string, action: LocalActivityAction) => {
			trackLocalActivity({ contentId, action }, setLocalActivity, getLocalActivity);
		},
		[setLocalActivity, getLocalActivity],
	);

	return { track };
};
